export default {
  client: { addFilter: () => {} },
  notify(err) {
    /* eslint-disable */
    console.error(err);
    /* eslint-enable */
    return Promise.resolve('[logged to console]');
  }
};
